import { useMutation } from "react-query";
import { getFreshAccessToken } from "../use-user";

const ADD_STATUS = `
  mutation AddStatus($id: String!, $input: StatusInput!) {
    addStatus(id: $id, input: $input) {
      message
      eventId
      queued
    }
  }
`;

export const useAddStatus = () => {
  return useMutation({
    mutationFn: async (variables) => {
      const accessToken = getFreshAccessToken();
      const res = await fetch(`${process.env.REACT_APP_TES_URL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-client-id": process.env.REACT_APP_CLIENT_ID || "lego-test",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          query: ADD_STATUS,
          variables,
        }),
      });

      const json = await res.json();

      if (json.errors) {
        throw new Error(JSON.stringify(json.errors));
      }

      return json.data;
    },
  });
};
